module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=GU - Guam.1f37f2a3.svg";